import React, { useState } from 'react';

/** @jsx jsx */
import { Styled, jsx } from "theme-ui";

const Tech = ({ technology }) => {
  const [hoverName, setHoverName] = useState(false);
  const { name, photo } = technology;

  return (
    <div
      onMouseEnter={() => setHoverName(true)}
      onMouseLeave={() => setHoverName(false)}
      sx={{
        position: "relative",
        display: "grid",
        justifyItems: "center",
        alignItems: "center"
      }}
    >
      <img
        name={name}
        src={photo}
        sx={{
          transition: "all 0.3s ease-in-out",
          position: "absolute",
          maxWidth: 100,
          filter: `saturate(0.5) ${hoverName ? "blur(5px)" : ""}`,
          zIndex: 1
        }}
      />
      
      <p
        sx={{
          visibility: hoverName ? "block" : "hidden",
          zIndex: 100,
          fontWeight: "bold"
        }}
      >
        {name}
      </p>
    </div>
  )
}

export default Tech;
